import {
    loadFile,
    lonLat2Mercator,
    mercator2lonLat
} from "../utils/tools";
import CommonTools from "../utils/common"
import { default as mapApp } from '@/map/init.js'
import request from '../../utils/request-common';
/**
 * 气象检测
 */
export default class WeatherMapActions extends esmap.ESEventDispatcher {

    constructor(map) {
        super();

        this.map = map

        this.floor = null;
        this.imageLayer = null;
        this.effectLayer = null;
        this.waterEffectLayer = null;

        this.seaHydraulicsCoords = [];
        this.seaHydraulicsWorker = null;
        this.isShowSeaHydraulics = false;
        this.currScaleLevel = 12;
        this.waveLinesConfigs = {
            12: {
                gapDistance: 500,
                lineLength: 500,
                lineWidth: 2.5,
            },
            13: {
                gapDistance: 450,
                lineLength: 450,
                lineWidth: 2.5
            },
            14: {
                gapDistance: 300,
                lineLength: 300,
                lineWidth: 2.5
            },
            15: {
                gapDistance: 200,
                lineLength: 150,
                lineWidth: 2.5
            },
            16: {
                gapDistance: 100,
                lineLength: 80,
                lineWidth: 2.5
            },
            17: {
                gapDistance: 50,
                lineLength: 50,
                lineWidth: 2.5
            },
            18: {
                gapDistance: 0,
                lineLength: 30,
                lineWidth: 2.5
            }
        }
        this.isShowCoordPoints = false;

        this.windMarker = null;
        this.fogMarker = null;

        this.isInitComplete = false;

        // 水动力气泡
        this.iswaterSwitch = false
        this.waterPopMarker = null
        this.waterPopVueComponent = null

    }

    // 外部初始化
    init () {
        if (this.isInitComplete) {
            this.resetView();
            // TODO: 

            return;
        }
        this._init();
        this.isInitComplete = true;
    }

    // 内部首次初始化层对象至地图
    _init () {
        // 获取层
        this.floor = this.map.getBuildingById(0).getFloor(1);
        // layer name 都填上好对应交互名称(建议唯一)，方便以后全局查找层对象
        //创建普通标注层    
        // this.imageLayer = this.floor.getOrCreateLayerByName('homeImg', esmap.ESLayerType.IMAGE_MARKER)
        //创建特效标注层    
        this.waterEffectLayer = new esmap.ESEffectTool.EffectLayer('sea_hydraulics', esmap.ESLayer.EFFECT_MARKER);
        this.effectLayer = new esmap.ESEffectTool.EffectLayer('2d_weather', esmap.ESLayer.EFFECT_MARKER);

        // this.floor.addLayer(this.imageLayer);
        esmap.ESEffectTool.addLayerToMap(this.waterEffectLayer);
        esmap.ESEffectTool.addLayerToMap(this.effectLayer);
    }

    // 重置视角
    resetView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 296.85, "pitchAngle": 57.71, "radius": 1831.05, "x": 13150451.35, "y": 4749960.05, "z": 0, "time": 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 加载当前交互模块基础配置数据
    loadActionData () {
        let self = this
        esmap.ESJsonFileLoader('./assets/actions/weather.json').then((data) => {
            console.log(data);
        })
    }

    // 初始化水动力数据展示
    initWaterWave () {
        let self = this;
        self.loadWaterWaveCoords();
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 0, "pitchAngle": 0, "radius": 29296.88, x: 13143254.19, y: 4744199.35, "z": 0,
            callback: function () {
                setTimeout(() => {
                    esmap.ESTileMap.Tools.setControlsConfigs({
                        minLevel: 12,
                        maxLevel: 18,
                        maxPolarAngle: 0.001
                    })
                }, 500)
            }
        })

    }

    // 加载水动力数据
    loadWaterWaveCoords () {
        let self = this;
        mapApp.mapContainer.clickShadeSign = true
        loadFile("./data/water/extractResult/Fengnan_jw.dat").then(data => {
            // console.log(data)

            let result = [];

            let list = data.split("\n");
            for (let i = 0, len = list.length; i < len; i++) {
                let str = list[i].split("\t");
                if (str.length == 2) {
                    let lon = str[0].trim() * 1;
                    let lat = str[1].split("\r")[0] * 1;
                    // console.log(lon, lat);
                    let wgs84 = [lon, lat];
                    let gcj02 = esmap.ESMapUtil.WGS84ToGCJ02(wgs84);
                    let mc = lonLat2Mercator(gcj02[0], gcj02[1]);
                    result.push({ x: mc[0], y: mc[1], height: 5 });
                }
            }
            this.seaHydraulicsCoords = result;

            // let smMp = new SimplifyMutiPoints();
            // let resultList = smMp.getProcessPoints(pointsList, 50);
            // // console.log(resultList);

            self.seaHydraulicsWorker = new ESSeaHydraulicsWorker();

            self.seaHydraulicsWorker.addEventListener('dataUpdate', function (event) {
                self.dispatchEvent({ type: 'seaHydraulicsUpdateComplete' })
                if (event.message == 'update') {

                    let config = self.waveLinesConfigs[self.currScaleLevel];

                    esmap.ESEffectTool.water.removeWaveLines();
                    esmap.ESEffectTool.water.createWaveMarker({
                        color: "#83effd", // 颜色
                        speed: 0.3,
                        height: -2, // 离地板高度
                        lineWidth: config.lineWidth, // 线宽（缩放固定）
                        imgUrl: "./image/wave_line.png"
                    });
                    esmap.ESEffectTool.water.updateWaveLines(event.data, config.lineLength);
                    self.isShowSeaHydraulics = true;
                    setTimeout(function () {
                        mapApp.mapContainer.clickShadeSign = false
                    }, 1000);
                }
            });

            //self.initTestCoordPoints(result);
            self.loadWaterWaveData(172800);
        })
    }

    loadWaterWaveData (timeStr) {
        let self = this;
        mapApp.mapContainer.clickShadeSign = true
        loadFile('./data/water/extractResult/Time' + timeStr + '.00s.dat').then(list => {
            // console.log(list);
            self.seaHydraulicsWorker.setData({
                coords: self.seaHydraulicsCoords,
                extent: {
                    minx: 13129369.818817552, miny: 4733151.119552532,
                    maxx: 13158561.181615127, maxy: 4756318.975784461
                },
                waterDirectData: list
            });

            let config = self.waveLinesConfigs[self.currScaleLevel];
            self.seaHydraulicsWorker.getData({
                gapDistance: config.gapDistance
            });
        }, () => {
            console.log('获取不到当前时刻的数据');
        })
    }

    updateWaterWaveConfig (level) {
        // 瓦片底图等级缩放更新
        if (this.isShowSeaHydraulics) {
            if (level >= 12) {
                if (this.seaHydraulicsWorker) {
                    // this.currGapDistance = this.pointsGapDistance - ((level - 12) * 100);
                    // // console.log(gapDistance);
                    // if (this.currGapDistance >= 0) {
                    //     this.seaHydraulicsWorker.getData({
                    //         gapDistance: this.currGapDistance
                    //     });
                    // }
                    level = level > 18 ? 18 : level;
                    let config = this.waveLinesConfigs[level];
                    console.log('sea water config:', config, level)
                    mapApp.mapContainer.clickShadeSign = false
                    this.seaHydraulicsWorker.getData({
                        gapDistance: config.gapDistance
                    });
                    this.currScaleLevel = level;
                }
            }
        }
    }

    // 恢复控制器默认配置
    resetControls () {
        esmap.ESTileMap.Tools.resetControlsConfigs();
    }

    // 关闭水动力展示
    closeWaterWave () {
        esmap.ESTileMap.Tools.resetControlsConfigs();
        esmap.ESEffectTool.water.removeWaveLines();
        this.isShowSeaHydraulics = false;
        mapApp.weatherMapActions.waterClickSwitch(false)
    }

    // 展示风场标注
    showWindMarker () {
        if (!this.windMarker) {
            this.windMarker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.PLANE_WIND, {
                x: 13150711.6406659, y: 4750672.168107909,
                height: 50,
                // color: params.color,
                radius: 5000,
                seeThrough: true,
            })
            this.effectLayer.addMarker(this.windMarker);
        } else {
            this.windMarker.visible = true;
        }
    }

    // 展示能见度标注
    showFogMarker () {
        if (!this.fogMarker) {
            this.fogMarker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.PLANE_FOG, {
                x: 13150711.6406659, y: 4750672.168107909,
                height: 50,
                // color: params.color,
                radius: 5000,
                seeThrough: true,
            })
            this.effectLayer.addMarker(this.fogMarker);
        } else {
            this.fogMarker.visible = true;
        }
    }

    // 隐藏所有气象标注
    hideAllWeatherMarker () {
        if (this.windMarker) {
            this.windMarker.visible = false;
        }
        if (this.fogMarker) {
            this.fogMarker.visible = false;
        }
    }

    // 清除所有气象标注
    clearWeatherMarker () {
        this.effectLayer.removeAll();
        this.windMarker = null;
        this.fogMarker = null;
    }


    // 水动力坐标位置测试
    initTestCoordPoints (result) {
        let self = this
        loadFile('./data/water/extractResult/Time172800.00s.dat').then(list => {
            self.seaHydraulicsWorker.setData({
                coords: result,
                extent: {
                    minx: 13129369.818817552, miny: 4733151.119552532,
                    maxx: 13158561.181615127, maxy: 4756318.975784461
                },
                waterDirectData: list
            });

            self.seaHydraulicsWorker.getData({
                gapDistance: 0
            });
        })

        loadFile('./data/boats/cur_aismove.csv').then(data => {
            let result = [];

            let list = data.split("\n");
            list.shift();
            for (let i = 0, len = list.length; i < len; i++) {
                let str = list[i].split(",");
                if (str.length > 3) {
                    let lon = str[1] * 1;
                    let lat = str[2] * 1;
                    // console.log(lon, lat);
                    // let wgs84 = [lon, lat];
                    // let gcj02 = esmap.ESMapUtil.WGS84ToGCJ02(wgs84);
                    let mc = lonLat2Mercator(lon, lat);
                    result.push({ x: mc[0], y: mc[1], height: 20 });
                }
            }

            console.log(result);

            self.addPointsMaker({
                coords: result,
                color: '#ff0000',
                animateType: 'breath', // 同频闪烁
                pointSize: 10,
                height: 5,
            })
        })

        // 锁定缩放操作
        esmap.ESTileMap.Tools.setControlsConfigs({
            minLevel: 10,
            maxLevel: 18,
            maxPolarAngle: 0
        })
    }

    // 水动力坐标位置特效点测试
    updateTestCoordPoints (coords) {
        if (!this.isShowCoordPoints) {
            this.addPointsMaker({
                coords: coords,
                color: '#fff700',
                animateType: 'breath', // 同频闪烁
                pointSize: 5,
                height: 5,
            })
            this.isShowCoordPoints = true;
        }
    }

    //创建点云标注
    addPointsMaker (params) {
        let pointsMarker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.POINTS, {
            height: params.height, // 离地板高度
            pointSize: params.pointSize, // 点大小
            color: params.color, // 颜色
            animateType: params.animateType, // 闪烁类型
            points: params.coords, // 点集
            isShine: params.isShine, // 是否发光（需要开启开启全屏特效）
        });
        this.waterEffectLayer.addMarker(pointsMarker);
        return pointsMarker;
    }

    //水动力坐标显示信息的开关函数
    waterClickSwitch (boolean) {
        this.iswaterSwitch = boolean
        if (!boolean) {
            this.waterPopVueComponent.popTips.visible = false
            // this.waterPopMarker?.close()
            if(this.waterPopMarker) this.waterPopMarker.close()
            this.waterPopMarker = null
        }
    }


    //点击水动力坐标显示信息
    async waterMapClick (e) {
        if (!this.iswaterSwitch) return
        this.waterPopVueComponent.popTips.visible = true

        const [x, y] = [e.hitCoord.x, e.hitCoord.y]

        this.waterPopMarker = CommonTools.addPopMarker({ x, y })
        this.waterPopMarker.onUpdatePosition((transformStyle) => {
            this.waterPopVueComponent.popTips.transformStyle = transformStyle
        })

        const [lon, lat] = mercator2lonLat(x, y)
        Object.assign(this.waterPopVueComponent, { lon, lat })
        try {
            const { data } = await request('fn/gridHydro', { lon, lat });
            this.waterPopVueComponent.location = data.water_power ? data.water_power : {}
        } catch (err) {
            console.log('获取数据失败！', err)
        }
    }

}